import React from 'react';

const Welcome = () => {
	return (
		<div className='flex-1 flex w-screen bg-gray-light justify-center items-center text-xl md:text-3xl text-center'>
			Welcome to Chat-e.
			<br />
			You might want to sign in.
		</div>
	);
};

export default Welcome;
